import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Snow",
  "description": "",
  "published": "2007-03-19T00:00:00.000Z",
  "redirect_from": ["/blog/snow/swizec/259"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`It's spring already right? It was nigh on 20°C outside even just yesterday was it not? Well apaprently something's decided that spring is over and we are finally having some winter weather ... only four months late too. Yay.`}</p>
    <p>{`Apparently that global warming thing everyone's been talking about lately has really been rearing its ugly head lately. There were all sorts of weird things happening yesteryear with the crazy snowy winter all over Europe and now ... well there has been absolutely no winter around here and from what I hear pretty much all over Europe. Well, here she is now. There's been heavy snowfall all day and might I jsut add it was bloody fun driving in these conditions.`}</p>
    <p>{`It's a bit difficult to wrap one's head around, but science tells us that global warming doesn't make the environment warmer, but instead makes it more chaotic. I was rather glad growing up with the idea of something like constant season, hopefully it won't change too much.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      